/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { FC } from 'react';
import {
    Edit,
    TextInput,
    DateInput,
    PasswordInput,
    Toolbar,
    useTranslate,
    SelectInput,
    FormWithRedirect,
    TextField,
    Show,
    TabbedShowLayout,
    Tab,
    AutocompleteInput,
    required,
    email,
    BooleanInput,
    useMutation,
    useNotify,
    useDataProvider,
} from 'react-admin';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Divider,
    Button,
    makeStyles,
    Grid,
    Switch,
    FormControlLabel,
    Chip,
} from '@material-ui/core';

import Aside from './Aside';
import FullNameField from '../fields/users/FullNameField';
import { validatePasswords } from './UserCreate';
import { Customer, FieldProps } from '../types';
import EditForm from './UserEdit';
import DocumentsTab from './tabs/DocumentsTab';
import FacturesTab from './tabs/FacturesTab';

const useStyles = makeStyles(theme => ({
    documentContainer: {
        marginBottom: theme.spacing(2),
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 500,
    },
    linkButton: {
        color: '#fff',
        backgroundColor: '#B29A5E',
        marginRight: theme.spacing(1),
        '&:hover': {
            backgroundColor: '#B29A2E',
        },
    },
    gridContainer: {
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    customCardContent: {
        padding: theme.spacing(2),
    },
}));

export const ValidationSwitcher = ({ record }) => {
    const classes = useStyles();
    const [validations, setValidations] = React.useState(
        record?.validations || []
    );
    const dataProvider = useDataProvider();
    const notify = useNotify();

    // Check if all validations are validated
    const allValidated = validations.every(
        validation => validation.validated === true
    );
    const validationCount = validations.length;
    const validatedCount = validations.filter(v => v.validated === true).length;

    const handleAllValidationsToggle = async newValidated => {
        const updatedValidations = validations.map(validation => ({
            ...validation,
            validated: newValidated,
        }));

        setValidations(updatedValidations);

        try {
            await dataProvider.update('livreurs', {
                id: record.id,
                data: { validations: updatedValidations },
                previousData: record,
            });

            notify(
                newValidated
                    ? 'Toutes les validations ont été activées'
                    : 'Toutes les validations ont été désactivées',
                'success'
            );
        } catch (error) {
            console.error('Error updating validations:', error);
            setValidations(record?.validations || []);
            notify('Erreur lors de la mise à jour des validations', 'error');
        }
    };

    return (
        <Box>
            <FormControlLabel
                control={
                    <Switch
                        checked={allValidated}
                        onChange={e =>
                            handleAllValidationsToggle(e.target.checked)
                        }
                        color="primary"
                    />
                }
                label={`Toutes les validations (${validatedCount}/${validationCount})`}
            />

            {validations.length > 0 && (
                <Box mt={1}>
                    {validations.map((validation, index) => (
                        <Box
                            key={validation._id || index}
                            mb={1}
                            display="flex"
                            alignItems="center"
                        >
                            <Chip
                                label={`${validation.type}: ${
                                    validation.validated
                                        ? 'Validé'
                                        : 'En attente'
                                }`}
                                color={
                                    validation.validated ? 'primary' : 'default'
                                }
                                size="small"
                                style={{ marginRight: 8 }}
                            />
                            {validation.code && (
                                <Typography
                                    variant="caption"
                                    style={{ marginLeft: 8 }}
                                >
                                    Code: {validation.code}
                                </Typography>
                            )}
                            <Typography
                                variant="caption"
                                style={{ marginLeft: 8 }}
                            >
                                Tentatives: {validation.tries || 0}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

const UserTitle: FC<FieldProps<Customer>> = ({ record }) =>
    record ? <FullNameField record={record} size="32" /> : null;

const EditTitle: FC<FieldProps<Customer>> = ({ record }) =>
    record ? null : null;

const EditUser = (props: any) => {
    return (
        <Edit
            title={<EditTitle />}
            aside={<Aside />}
            undoable={false}
            component="div"
            {...props}
        >
            <EditForm />
        </Edit>
    );
};

const UserEdit = (props: any) => {
    return (
        <Show {...props} component="div" title={<UserTitle />} actions={false}>
            <TabbedShowLayout>
                <Tab label="Detail">
                    <EditUser {...props} />
                </Tab>
                <Tab label="Documents">
                    <DocumentsTab {...props} />
                </Tab>
                <Tab label="Factures">
                    <FacturesTab {...props} />
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

export default UserEdit;
